module.exports = __webpack_public_path__ + "static/media/computer-icon.2b621369.svg";